import { useKeyboardAction } from "../hooks/useKeyboardAction";
import { KeyboardKey } from "../browser/keyboard";

// `useKeyboardAction` needs to be part of a component so it can use the hook
export const EscapePressHandler = ({
  onEscapePress,
}: {
  onEscapePress: () => void;
}) => {
  useKeyboardAction({
    keyDownBindings: [
      {
        keyName: KeyboardKey.Escape,
        onKeyDown: onEscapePress,
      },
    ],
  });
  return null;
};
